import { makeAutoObservable } from 'mobx';
import http from '../services/http';
import { applyPrimaryPalette } from '../utils/Palette';

class UserStore {
  user?: IUser;
  isLoading = false;

  async findUser() {
    this.isLoading = true;
    try {
      const result = await http.get('/user');
      this.user = result.data;

      applyPrimaryPalette(this.user?.color);
    } finally {
      this.isLoading = false;
    }
  }

  async onUpdate(values: any) {
    this.isLoading = true;
    try {
      const result = await http.post('/user', values);
      this.user = result.data;

      applyPrimaryPalette(this.user?.color);
    } finally {
      this.isLoading = false;
    }
  }

  async onAcceptTerms() {
    this.isLoading = true;
    try {
      const result = await http.post('/user/accept-terms');
      this.user = result.data;
    } finally {
      this.isLoading = false;
    }
  }

  constructor() {
    makeAutoObservable(this);
  }
}

const userStore = new UserStore();

export default userStore;

interface IUser {
  firstName: string;
  lastName: string;
  initials: string;
  avatar: string;
  color: string;
  logo: string;
  totalProjects: number;
  isHost?: boolean;
  isTermsApproval?: boolean;
}
